module.exports = __webpack_public_path__ + "static/media/ic_done.4883f5e2.svg";